export default "__VITE_ASSET__eb4a1b65__"